export default __webpack_public_path__ + "static/media/logo.f4e1e6a0.svg";